import VideoPlayer from "./VideoPlayer";

export function handleVideoPlayers(){
    $('body').on('click', '.js-play-video', function(){
        $(this).addClass('video-player__thumbnail--hidden');
        let videoPlayer = new VideoPlayer($(this));
        videoPlayer.show();
        return false;
    });
}
